import { IconProps } from "../../utils/global-types/global-types";

const SortZAIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M5.764 15.99a.656.656 0 0 1-.657-.657V5.547l-.729.164a.603.603 0 0 1-.649-.9l1.518-2.52a.604.604 0 0 1 1.033 0l1.518 2.52a.603.603 0 0 1-.649.9l-.73-.164v9.786a.656.656 0 0 1-.655.656M14.325 15.114l-1.636-4.582a.77.77 0 0 0-.722-.508h-.058a.77.77 0 0 0-.722.508L9.55 15.114a.576.576 0 1 0 1.088.378l.177-.52h2.244l.177.52a.576.576 0 1 0 1.088-.379m-3.132-1.231.737-2.16h.016l.737 2.16zM13.934 3.365a.767.767 0 0 0-.615-1.225h-2.875a.57.57 0 1 0 0 1.139h2.093v.016l-2.594 3.48A.767.767 0 0 0 10.558 8h2.95a.57.57 0 1 0 0-1.139H11.34v-.016z"
    ></path>
  </svg>
);

export default SortZAIcon;
